import React, { useCallback, useEffect, useReducer, useState } from "react";
import * as Yup from "yup";
import { Form, Formik } from "formik";
import {
  CustomAutocomplete,
  CustomButton,
  CustomCard,
  CustomIconButton,
  CustomInput,
  CustomNumberSelector,
  CustomRangeSlider,
  DropzoneComponent,
} from "../../../../../../../../Components";
import { UnitViewsTypeIdEnum } from "../../../../../../../../Enums";
import { GetFileTypeIcon } from "../../../../../../NewContactsView/ContactOverview/UI";
import { formatBytes } from "react-dropzone-uploader";
import { useVerticalNav } from "../../../../../../../../Contexts/VerticalNavContext";
import { useSelectedTheme, useTranslate } from "../../../../../../../../Hooks";
import { Box, Divider, Paper, Typography } from "@material-ui/core";
import clsx from "clsx";
import { CloseXIcon, DeleteIcon } from "../../../../../../../../assets/icons";
import {
  CreatePropertyUnitModel,
  GetAllPropertyUnitTypeAPI,
  GetPropertyUnitModelById,
  lookupItemsGetId,
  UpdatePropertyUnitModelAPI,
} from "../../../../../../../../Services";

// styles
import useStyles from "./styles";

const validationSchema = Yup.object().shape({
  propertyUnitModelName: Yup.string().required("Name Unit Model is required"),
  area: Yup.string().required("size is required"),
});

const UnitsModelsManangementSideMenu = ({
  onOpen,
  onClose,
  activeItem,
  propretyId,
  reloadData,
}) => {
  const styles = useStyles();
  const {
    theme: { palette },
  } = useSelectedTheme();
  const { translate } = useTranslate("NewPropertiesView");
  const { setAlertBoxContent } = useVerticalNav();
  const reducer = useCallback((state, action) => {
    if (action.id !== "edit") return { ...state, [action.id]: action.value };
    return {
      ...action.value,
    };
  }, []);
  const nmbrSelectArray = [1, 2, 3, 4, 5, 6, 7, 8];
  const [propertyUnitTypes, setPropertyUnitTypes] = useState({
    result: [],
    totalCount: 0,
  });
  const [views, setViews] = useState({
    result: [],
    totalCount: 0,
  });
  const [filesAccepted, setFilesAccepted] = useState([]);
  const [uploadedFileId, setUploadedFileId] = useState(null);
  const [uploadedFiles, setUploadedFiles] = useState([]);
  const [isLoading, setIsLoading] = useState(false);
  const [selectedItem, setSelectedItem] = useState({});
  const [state, setState] = useReducer(reducer, {
    propertyId: propretyId,
    propertyUnitModelName: null,
    area: null,
    bedroomNo: null,
    bathroomNo: null,
    unitsNo: null,
    sellingPriceFrom: null,
    sellingPriceTo: null,
    rentPerYearFrom: null,
    rentPerYearTo: null,
    primaryView: [],
    secondaryView: [],
    unitTypeId: null,
    parkingNo: null,
    maidsRoomNo: null,
    storeRoomNo: null,
    backyardNo: null,
    laundryRoomNo: null,
    utilityRoomNo: null,
    studyRoomNo: null,
    unitModelImage: null,
    unitModelFileId: null,
    unitModelDocuments: null,
    propertyUnitType: null,
    files: [],
    unitsNo: null,
    serviceCharge: null,
  });

  const isEdit = !!(activeItem && activeItem.propertyUnitModelId);
  const initialValues = isEdit ? selectedItem : state;

  const getAllPropertyUnitType = useCallback(async () => {
    const res = await GetAllPropertyUnitTypeAPI(propretyId);
    if (!(res && res.status && res.status !== 200)) {
      setPropertyUnitTypes({
        result: (res && res[0] && res[0].propertyUnitType) || [],
        totalCount: (res && res.totalCount) || 0,
      });
    } else {
      setPropertyUnitTypes({
        result: [],
        totalCount: 0,
      });
    }
  }, []);

  const GetAllViews = useCallback(async () => {
    const res = await lookupItemsGetId({
      lookupTypeId: UnitViewsTypeIdEnum.lookupTypeId,
    });
    if (!(res && res.status && res.status !== 200)) {
      setViews({
        result: res || [],
        totalCount: 0,
      });
    } else {
      setViews({
        result: [],
        totalCount: 0,
      });
    }
  }, []);

  const handleFilesAccepted = (files) => {
    setFilesAccepted(files);
  };

  const formatUploadedDocumentToMapp = () => {
    if (uploadedFileId) {
      setUploadedFiles((prevUploadedFiles) => [
        ...prevUploadedFiles,
        filesAccepted[0],
      ]);
      setUploadedFiles((prevUploadedFiles) => {
        const updatedFiles = [...prevUploadedFiles];
        if (updatedFiles?.length > 0) {
          updatedFiles[updatedFiles.length - 1] = {
            ...updatedFiles[updatedFiles.length - 1],
            fileId: uploadedFileId,
            fileSize: updatedFiles[updatedFiles?.length - 1]?.size,
            fileName: updatedFiles[updatedFiles?.length - 1]?.path,
            fileType: updatedFiles[updatedFiles?.length - 1]?.type,
          };
        }
        return updatedFiles;
      });
    }
  };
  
  const handleDeleteUploadedFile = (index) => {
    setUploadedFiles((prevUploadedFiles) =>
      prevUploadedFiles.filter((_, i) => i !== index)
    );
  };

  const handleSubmit = async (values) => {
    try {
      setIsLoading(true);
      const unitModelBody = {
        propertyId: values.propertyId,
        propertyUnitModelName: values.propertyUnitModelName || "",
        area: values.area || 0,
        bedroomNo: values.bedroomNo || 0,
        bathroomNo: values.bathroomNo || 0,
        unitsNo: values.unitsNo || "",
        sellingPriceFrom: values.sellingPriceFrom || 0,
        sellingPriceTo: values.sellingPriceTo || 0,
        rentPerYearFrom: values.rentPerYearFrom || 0,
        rentPerYearTo: values.rentPerYearTo || 0,
        primaryView: isEdit
          ? values?.primaryData || []
          : values?.primaryView || [],
        secondaryView: isEdit
          ? values?.secondaryData || []
          : values?.secondaryView || [],
        unitTypeId: values.unitTypeId || 0,
        parkingNo: values.parkingNo || 0,
        maidsRoomNo: values.maidsRoomNo || 0,
        storeRoomNo: values.storeRoomNo || 0,
        backyardNo: values.backyardNo || 0,
        laundryRoomNo: values.laundryRoomNo || 0,
        utilityRoomNo: values.utilityRoomNo || 0,
        studyRoomNo: values.studyRoomNo || 0,
        unitModelImage: values.unitModelImage || 0,
        unitModelDocuments:
          (uploadedFiles.length > 0 &&
            uploadedFiles?.map((file) => ({
              fileId: file.fileId,
              fileName: file.fileName,
              fileSize: file.fileSize,
              fileType: file.fileType,
            }))) ||
          [],
        unitsNo: values.unitsNo || 0,
        propertyUnitType: values.propertyUnitType || null,
        serviceCharge: values.serviceCharge || 0,
        unitModelFileId:
          (state &&
            state.files &&
            state.files.length &&
            state.files[0] &&
            state.files[0].uuid) ||
          null,
      };
      const res = isEdit
        ? await UpdatePropertyUnitModelAPI(
            values.propertyUnitModelId,
            unitModelBody
          )
        : await CreatePropertyUnitModel(unitModelBody);
      if (!(res && res.status && res.status !== 200)) {
        setAlertBoxContent({
          display: true,
          variant: "success",
          title: isEdit
            ? translate("Unit-Model-Updated-successfully")
            : translate("Unit-Model-added-successfully"),
          onClose: () => {
            setAlertBoxContent(null);
          },
        });
        onClose();
        reloadData();
      } else {
        setAlertBoxContent({
          display: true,
          variant: "error",
          title: isEdit
            ? translate("Failed-to-Edit-the-Unit-Model")
            : translate("Failed-to-add-the-Unit-Model"),
          onClose: () => {
            setAlertBoxContent(null);
          },
        });
      }
    } catch (error) {
      setAlertBoxContent({
        display: true,
        variant: "error",
        title: translate("some-thing-wrong"),
        onClose: () => {
          setAlertBoxContent(null);
        },
      });
    } finally {
      setIsLoading(false);
    }
  };

  const getPropertyUnitModelById = useCallback(async () => {
    try {
      setIsLoading(true);
      const res = await GetPropertyUnitModelById(
        activeItem && activeItem.propertyUnitModelId
      );
      if (!(res && res.status && res.status !== 200)) {
        setSelectedItem(res);
      } else setSelectedItem(null);
    } catch (error) {
    } finally {
      setIsLoading(false);
    }
  }, [activeItem]);

  useEffect(() => {
    getAllPropertyUnitType();
  }, [getAllPropertyUnitType]);

  useEffect(() => {
    GetAllViews();
  }, []);

  useEffect(() => {
    formatUploadedDocumentToMapp();
  }, [uploadedFileId]);

  useEffect(() => {
    if (activeItem && activeItem.propertyUnitModelId) {
      getPropertyUnitModelById();
    }
  }, [activeItem]);

  useEffect(() => {
    if (selectedItem?.unitModelDocuments?.length) {
      const initializedDocs = selectedItem.unitModelDocuments.map((doc) => ({
        fileId: doc.fileId,
        fileName: doc.fileName,
        fileSize: doc.fileSize,
        fileType: doc.fileType,
      }));
      setUploadedFiles(initializedDocs);
    } else {
      setUploadedFiles([]);
    }
  }, [selectedItem]);

  return (
    <Paper
      className={clsx(styles.unitsModelsManangementSideMnue, {
        [styles.hidden]: !onOpen,
      })}
    >
      <Box className={styles.header}>
        <Box className={styles.containerTitlePlusBackIcon}>
          <Typography variant="h6" className={styles.mainTitle}>
            {isEdit
              ? translate("Edit-unit-model")
              : translate("Add-unit-model")}
          </Typography>
          <CustomIconButton
            variant="text"
            size="none"
            boxShadow="none"
            color="tertiaryColor"
            hideHoverBg
            onClick={onClose}
          >
            <CloseXIcon
              width="24"
              height="24"
              fill={palette.foreground.quinary}
            />
          </CustomIconButton>
        </Box>
        <Typography variant="h6" className={styles.subTitle}>
          {translate(
            "Use-this-form-to-add-or-update-a-consent-record-for-contact-engagements-Choose-the-consent-status-specify-the-reason-and-provide-evidence-as-needed"
          )}
        </Typography>
      </Box>
      <Box className={styles.wrapperContentSideMenu}>
        <Formik
          initialValues={initialValues}
          validationSchema={validationSchema}
          onSubmit={handleSubmit}
          enableReinitialize
        >
          {({ values, errors, touched, handleSubmit, setFieldValue }) => (
            <Form
              onSubmit={handleSubmit}
              className={styles.containerFormAddUnitModel}
            >
              <Box className={styles.containerInputSection}>
                <Typography className={styles.titleFiled}>
                  {translate("Model-name")}
                </Typography>
                <CustomInput
                  placeholder={translate("Enter")}
                  hasSearchIcon={false}
                  style={{ maxWidth: "100%" }}
                  value={values.propertyUnitModelName}
                  onChange={(e) => {
                    setFieldValue("propertyUnitModelName", e.target.value);
                  }}
                  hasError={
                    touched.propertyUnitModelName &&
                    errors.propertyUnitModelName
                  }
                  errorMessage={
                    touched.propertyUnitModelName &&
                    errors.propertyUnitModelName
                      ? errors.propertyUnitModelName
                      : null
                  }
                  submitted={
                    touched.propertyUnitModelName &&
                    errors.propertyUnitModelName
                  }
                />
              </Box>
              <Divider />
              <Box className={styles.containerInputSection}>
                <Typography className={styles.titleFiled}>
                  {translate("Unit-type")}
                </Typography>
                <CustomAutocomplete
                  placeholder={`Select`}
                  className={styles.containerFormAddUnitModel}
                  options={
                    (propertyUnitTypes && propertyUnitTypes.result) || []
                  }
                  selectedValues={values.propertyUnitType}
                  onChange={(e, newValue) => {
                    setFieldValue("propertyUnitType", newValue);
                  }}
                  getOptionLabel={(option) =>
                    (option && option.lookupItemName) || ""
                  }
                  getOptionValue={(option) =>
                    (option && option.lookupItemId) || ""
                  }
                  renderOption={(option) =>
                    (option && option.lookupItemName) || ""
                  }
                />
              </Box>
              <Divider />
              <Box className={styles.containerInputSection}>
                <Typography className={styles.titleFiled}>
                  {translate("Units-number")}
                </Typography>
                <CustomInput
                  placeholder={translate("Enter")}
                  hasSearchIcon={false}
                  style={{ maxWidth: "100%" }}
                  value={values.unitsNo}
                  onChange={(e) => {
                    setFieldValue("unitsNo", e.target.value);
                  }}
                />
              </Box>
              <Divider />
              <Box className={styles.containerInputSection}>
                <Typography className={styles.titleFiled}>
                  {translate("Bedrooms")}
                </Typography>
                <CustomNumberSelector
                  valuesArray={nmbrSelectArray}
                  value={values?.bedroomNo}
                  onChange={(value) => {
                    setFieldValue("bedroomNo", value);
                  }}
                />
              </Box>
              <Divider />
              <Box className={styles.containerInputSection}>
                <Typography className={styles.titleFiled}>
                  {translate("BathRoom")}
                </Typography>
                <CustomNumberSelector
                  valuesArray={nmbrSelectArray}
                  value={values?.bathroomNo}
                  onChange={(value) => {
                    setFieldValue("bathroomNo", value);
                  }}
                />
              </Box>
              <Divider />
              <Box className={styles.containerInputSection}>
                <Typography className={styles.titleFiled}>
                  {translate("Size")}
                </Typography>
                <CustomInput
                  placeholder={translate("1,000.00")}
                  hasSearchIcon={false}
                  style={{ maxWidth: "100%" }}
                  value={values?.area}
                  type="number"
                  onChange={(e) => {
                    setFieldValue("area", e.target.value);
                  }}
                  preInputText={translate("Sqft")}
                  hasError={touched.area && errors.area}
                  errorMessage={
                    touched.area && errors.area ? errors.area : null
                  }
                  submitted={touched.area && errors.area}
                />
              </Box>
              <Divider />
              <Box className={styles.containerInputSection}>
                <Typography className={styles.titleFiled}>
                  {translate("Selling-price-range")}
                </Typography>
                <CustomRangeSlider
                  value={[
                    Number(values?.sellingPriceFrom || 10000),
                    Number(values?.sellingPriceTo || 60000000),
                  ]}
                  handleChange={(e, newValue) => {
                    setFieldValue("sellingPriceFrom", newValue?.[0]);
                    setFieldValue("sellingPriceTo", newValue?.[1]);
                  }}
                  min={10000}
                  max={60000000}
                  valueLabelDisplay="off"
                  preInputText={translate("AED")}
                />
              </Box>
              <Divider />
              <Box className={styles.containerInputSection}>
                <Typography className={styles.titleFiled}>
                  {translate("Rent-price-range")}
                </Typography>
                <CustomRangeSlider
                  value={[
                    Number(values?.rentPerYearFrom || 10000),
                    Number(values?.rentPerYearTo || 60000000),
                  ]}
                  handleChange={(e, newValue) => {
                    setFieldValue("rentPerYearFrom", newValue?.[0]);
                    setFieldValue("rentPerYearTo", newValue?.[1]);
                  }}
                  min={10000}
                  max={60000000}
                  valueLabelDisplay="off"
                  preInputText={translate("AED")}
                />
              </Box>
              <Divider />
              <Box className={styles.containerInputSection}>
                <Typography className={styles.titleFiled}>
                  {translate("Service-charge")}
                </Typography>
                <CustomInput
                  placeholder={translate("1,000.00")}
                  hasSearchIcon={false}
                  style={{ maxWidth: "100%" }}
                  value={values?.serviceCharge}
                  onChange={(e) => {
                    setFieldValue("serviceCharge", e.target.value);
                  }}
                  preInputText={translate("ADE")}
                  type="number"
                />
              </Box>
              <Divider />
              <Box className={styles.containerInputSection}>
                <Typography className={styles.titleFiled}>
                  {translate("Parkings")}
                </Typography>
                <CustomNumberSelector
                  valuesArray={nmbrSelectArray}
                  value={values?.parkingNo}
                  onChange={(value) => {
                    setFieldValue("parkingNo", value);
                  }}
                />
              </Box>
              <Divider />
              <Box className={styles.containerInputSection}>
                <Typography className={styles.titleFiled}>
                  {translate("Maids-room")}
                </Typography>
                <CustomNumberSelector
                  valuesArray={nmbrSelectArray}
                  value={values?.maidsRoomNo}
                  onChange={(value) => {
                    setFieldValue("maidsRoomNo", value);
                  }}
                />
              </Box>
              <Divider />
              <Box className={styles.containerInputSection}>
                <Typography className={styles.titleFiled}>
                  {translate("Store-room")}
                </Typography>
                <CustomNumberSelector
                  valuesArray={nmbrSelectArray}
                  value={values?.storeRoomNo}
                  onChange={(value) => {
                    setFieldValue("storeRoomNo", value);
                  }}
                />
              </Box>
              <Divider />
              <Box className={styles.containerInputSection}>
                <Typography className={styles.titleFiled}>
                  {translate("Backyards")}
                </Typography>
                <CustomNumberSelector
                  valuesArray={nmbrSelectArray}
                  value={values?.backyardNo}
                  onChange={(value) => {
                    setFieldValue("backyardNo", value);
                  }}
                />
              </Box>
              <Divider />
              <Box className={styles.containerInputSection}>
                <Typography className={styles.titleFiled}>
                  {translate("Laundry-room")}
                </Typography>
                <CustomNumberSelector
                  valuesArray={nmbrSelectArray}
                  value={values?.laundryRoomNo}
                  onChange={(value) => {
                    setFieldValue("laundryRoomNo", value);
                  }}
                />
              </Box>
              <Divider />
              <Box className={styles.containerInputSection}>
                <Typography className={styles.titleFiled}>
                  {translate("Utility-room")}
                </Typography>
                <CustomNumberSelector
                  valuesArray={nmbrSelectArray}
                  value={values?.utilityRoomNo}
                  onChange={(value) => {
                    setFieldValue("utilityRoomNo", value);
                  }}
                />
              </Box>
              <Divider />
              <Box className={styles.containerInputSection}>
                <Typography className={styles.titleFiled}>
                  {translate("Study-room")}
                </Typography>
                <CustomNumberSelector
                  valuesArray={nmbrSelectArray}
                  value={values?.studyRoomNo}
                  onChange={(value) => {
                    setFieldValue("studyRoomNo", value);
                  }}
                />
              </Box>
              <Divider />
              <Box className={styles.containerInputSection}>
                <Typography className={styles.titleFiled}>
                  {translate("Primary-views")}
                </Typography>
                <CustomAutocomplete
                  placeholder="select"
                  variant="default"
                  multiple={true}
                  selectedValues={
                    isEdit
                      ? values?.primaryData || []
                      : values?.primaryView || []
                  }
                  options={views.result || []}
                  onChange={(e, newValue) => {
                    {
                      isEdit
                        ? setFieldValue("primaryData", newValue || [])
                        : setFieldValue("primaryView", newValue || []);
                    }
                  }}
                  renderOption={(option) => option?.lookupItemName || ""}
                  chipsLabel={(option) => option?.lookupItemName || ""}
                  getOptionLabel={(option) => option?.lookupItemName || ""}
                />
              </Box>
              <Divider />
              <Box className={styles.containerInputSection}>
                <Typography className={styles.titleFiled}>
                  {translate("Secondary-views")}
                </Typography>
                <CustomAutocomplete
                  placeholder="select"
                  variant="default"
                  multiple={true}
                  selectedValues={
                    isEdit
                      ? values?.secondaryData || []
                      : values?.secondaryView || []
                  }
                  options={views.result || []}
                  onChange={(e, newValue) => {
                    isEdit
                      ? setFieldValue("secondaryData", newValue || [])
                      : setFieldValue("secondaryView", newValue || []);
                  }}
                  renderOption={(option) => option?.lookupItemName || ""}
                  chipsLabel={(option) => option?.lookupItemName || ""}
                  getOptionLabel={(option) => option?.lookupItemName || ""}
                />
              </Box>
              <Divider />
              <Box className={styles.containerInputSection}>
                <Typography className={styles.titleFiled}>
                  {translate("Attachment")}
                </Typography>
                <Box className={styles.containerUpladedFilesCrads}>
                  <DropzoneComponent
                    accept="image/*,
                                     video/*,
                                     application/pdf,
                                     application/msword,
                                     application/vnd.openxmlformats-officedocument.wordprocessingml.document,
                                     application/vnd.ms-excel,
                                     application/vnd.openxmlformats-officedocument.spreadsheetml.sheet,
                                     text/plain,
                                     application/vnd.adobe.figma,
                                     application/illustrator,
                                     application/photoshop,
                                     application/vnd.adobe.indesign,
                                     application/aftereffects,
                                     audio/mp3,
                                     audio/wav,
                                     video/mp4,
                                     video/mpeg,
                                     video/avi,
                                     video/mkv,
                                     text/html,
                                     text/css,
                                     application/rss+xml,
                                     application/sql,
                                     application/javascript,
                                     application/json,
                                     text/x-java-source,
                                     application/xml,
                                     application/x-msdownload,
                                     application/x-dmg,
                                     application/zip,
                                     application/x-rar-compressed"
                    title={translate("SVG-PNG-JPG-or-GIF-max-800x400px")}
                    onFilesAccepted={handleFilesAccepted}
                    setUploadedFileId={setUploadedFileId}
                  />
                  {uploadedFiles && uploadedFiles?.length > 0 && (
                    <Box className={styles.containerUpladedFilesCrads}>
                      {uploadedFiles
                        .filter((file) => file?.fileType)
                        .map((uploadFile, index) => (
                          <CustomCard
                            boxShadow="xs"
                            borderRadius="xl"
                            borderColor="secondary"
                            classes={styles.CardUploadedFilesInfo}
                            key={index}
                          >
                            {GetFileTypeIcon(uploadFile?.fileType)}
                            <Box className={styles.ContainerFileUploadedInfo}>
                              <Box
                                className={styles.containerTitleAndDeleteIcon}
                              >
                                <Typography className={styles.TitleFileName}>
                                  {uploadFile?.fileName}
                                </Typography>
                                <DeleteIcon
                                  width="20"
                                  height="20"
                                  className={styles.DeleteIcon}
                                  style={{ cursor: "pointer" }}
                                  fill={palette.button.secondary_fg}
                                  onClick={() =>
                                    handleDeleteUploadedFile(index)
                                  }
                                />
                              </Box>
                              <Typography className={styles.FileSizeTitle}>
                                {formatBytes(Number(uploadFile?.fileSize))}
                              </Typography>
                            </Box>
                          </CustomCard>
                        ))}
                    </Box>
                  )}
                </Box>
              </Box>
              {/* footer action */}
              <Box className={styles.footerActions}>
                <CustomButton
                  variant="outlined"
                  color="secondary"
                  onClick={onClose}
                >
                  {translate("cancel")}
                </CustomButton>
                <CustomButton
                  type="submit"
                  variant="contained"
                  color="primary"
                  disabled={isLoading}
                >
                  {translate(
                    isEdit
                      ? translate("Edit-unit-model")
                      : translate("Add-unit-model")
                  )}
                </CustomButton>
              </Box>
            </Form>
          )}
        </Formik>
      </Box>
    </Paper>
  );
};

export default UnitsModelsManangementSideMenu;
